import queryString from 'querystring';

export const HTML_INPUT_DATE_FORMAT = 'dd-MMM-yyyy'

export function handleDefaults(defaultObj: {}, dynamicObj: {}) {
    return Object.assign(defaultObj, dynamicObj);
}

export function getQueryParams(query: string) {
    const params = query.replace('?', '');
    return queryString.parse(params);
}

// Until we can reliably use Coalescing Operator, this will suffice.
export function isDefined(x: undefined | null | any) {
    return x !== null && x !== undefined;
}

// Not truly random, please don't use for anything that needs any security
export function getRandomNumBetween(min: number, max: number) {
    return Math.random() * (max - min) + min;
}

// Not truly random, please don't use for anything that needs any security
export function getRandomStringOfLength(length: number): string {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i += 1) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

// Get locale param from URL
export function getLocale(): string {
    const params = getQueryParams(window.location.search);
    return (typeof params.locale === 'object' ? params.locale[0] : params.locale) || 'en-AU';
}
